import { render, staticRenderFns } from "./edit-message-patterns-variable-dialog.vue?vue&type=template&id=df851e2a&scoped=true&"
import script from "./edit-message-patterns-variable-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-message-patterns-variable-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df851e2a",
  null
  
)

export default component.exports